var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleChevronsBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833984 10.0002C0.833984 15.0628 4.93804 19.1668 10.0007 19.1668C15.0633 19.1668 19.1673 15.0628 19.1673 10.0002C19.1673 4.93755 15.0633 0.833496 10.0007 0.833496C4.93804 0.833496 0.833984 4.93755 0.833984 10.0002ZM17.5007 10.0002C17.5007 14.1423 14.1428 17.5002 10.0007 17.5002C5.85852 17.5002 2.50065 14.1423 2.50065 10.0002C2.50065 5.85803 5.85852 2.50016 10.0007 2.50016C14.1428 2.50016 17.5007 5.85803 17.5007 10.0002ZM12.7447 9.4109L13.9232 10.5894L10.0006 14.512L6.07805 10.5894L7.25656 9.4109L10.0006 12.155L12.7447 9.4109ZM12.7447 6.07756L10.0006 8.82164L7.25656 6.07756L6.07805 7.25607L10.0006 11.1787L13.9232 7.25607L12.7447 6.07756Z",
    fill: "black",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleChevronsBottom);
export default __webpack_public_path__ + "static/media/circle-chevrons-bottom.9a3af2091c2656dfcbd28b85f896d94d.svg";
export { ForwardRef as ReactComponent };